/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminTodoCompletionDto { 
    /**
     * Identifier of the action in the catalogue
     */
    actionId: string;
    /**
     * When the action was ticked off
     */
    completedAt: string;
    /**
     * Identifier of the administrator who ticked it
     */
    completedById: string;
    /**
     * Name of the administrator who ticked it, as captured at the time
     */
    completedByName: string;
}

